import type { RawParams } from "@uirouter/core";
import { isEqual, isNil } from "lodash";

import type { IRouterState } from "../IRouterState";

export const areParamsEqual = (params1: RawParams, params2: RawParams): boolean => {
    // Filter out null and undefined values from both objects
    const filteredParams1 = Object.fromEntries(Object.entries(params1).filter(([, value]) => !isNil(value)));
    const filteredParams2 = Object.fromEntries(Object.entries(params2).filter(([, value]) => !isNil(value)));

    return isEqual(filteredParams1, filteredParams2);
};

export const shouldResetParams = (fromState: IRouterState | null, toState: IRouterState): boolean => {
    if (!fromState?.name) {
        return false;
    }
    return fromState.name !== toState.name && toState.resetOnStateChange === true && toState.reset !== undefined;
};

export const getResetParams = (
    fromState: IRouterState | null,
    toState: IRouterState,
    fromParams: RawParams,
    toParams: RawParams,
): RawParams => {
    if (!toState.reset || !fromState) {
        return {};
    }

    if (typeof toState.reset === "function") {
        return toState.reset(fromState, toState, fromParams, toParams) || {};
    }

    if (typeof toState.reset === "object") {
        return toState.reset;
    }

    return {};
};

export const applyResetParams = (
    fromState: IRouterState | null,
    toState: IRouterState,
    fromParams: RawParams,
    toParams: RawParams,
): RawParams => {
    if (!shouldResetParams(fromState, toState)) {
        return toParams;
    }

    const resetParams = getResetParams(fromState, toState, fromParams, toParams);

    return {
        ...toParams,
        ...resetParams,
    };
};
